// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"3445312e","460":"52fb5635","625":"86741938","899":"6d996e4c","905":"74adbee4"}[chunkId] + ".chunk.css";
};